import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";

import { IMAGE_BASE_URL } from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";

function RequestSent() {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const tt = (key, fallback = "") =>
    t(`requestcar.${key}`, fallback);

  const [data, setData] = useState(null);

  // =====================================================
  // LOAD DATA FROM SESSION STORAGE
  // (set by SendRequestCar.jsx right before navigating here)
  // =====================================================

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("requestSentData");

      if (!stored) {
        console.warn("No requestSentData found in sessionStorage");
        navigate("/");
        return;
      }

      setData(JSON.parse(stored));

      // Clear it so a page refresh / back-nav doesn't resubmit
      // the same summary silently, once it's been read.
      // (Kept on refresh intentionally is also fine — comment
      // out the next line if you'd rather it persist.)
      // sessionStorage.removeItem("requestSentData");
    } catch (error) {
      console.error("Error reading requestSentData:", error);
      navigate("/");
    }
  }, [navigate]);

  // =====================================================
  // CAR IMAGE HELPER (same as BookACar.jsx / SendRequestCar.jsx)
  // =====================================================

  const getCarImage = (image) => {
    if (!image) return "";

    let imagePath = String(image).trim();

    if (!imagePath) return "";

    if (
      imagePath.startsWith("http://") ||
      imagePath.startsWith("https://")
    ) {
      return imagePath;
    }

    imagePath = imagePath.replace(/^\/+/, "");

    const imageBase =
      IMAGE_BASE_URL || "http://localhost:5555/uploads";

    if (imagePath.startsWith("images/")) {
      return `${imageBase}/${imagePath}`;
    }

    if (imagePath.startsWith("CarImage/")) {
      return `${imageBase}/images/${imagePath}`;
    }

    return `${imageBase}/images/CarImage/${imagePath}`;
  };

  if (!data) {
    return (
      <div
        className="container text-center"
        style={{ paddingTop: "100px", paddingBottom: "100px" }}
      >
        <p>{tt("loading", "Loading...")}</p>
      </div>
    );
  }

  const { car, form, criteria, fullbooking_no } = data;

  const carImage = getCarImage(car?.carmodel_image || car?.image);

  // =====================================================
  // ROW HELPER FOR THE 2-COLUMN DETAILS TABLE
  // =====================================================

  const Row = ({ leftLabel, leftValue, rightLabel, rightValue }) => (
    <tr>
      <td
       
        style={{ width: "25%", padding: "8px", background: "#fff", fontWeight: "600", borderBottom: "1px solid #d2d2d2", borderRight: "1px solid #d2d2d2"  }}
      >
        {leftLabel} :
      </td>
      <td style={{ width: "30%", padding: "8px", background: "#fff", borderBottom: "1px solid #d2d2d2", borderRight: "1px solid #d2d2d2"   }}>
        {leftValue || "-"}
      </td>
      <td
        
        style={{ width: "25%", padding: "8px", background: "#fff", fontWeight: "600", borderBottom: "1px solid #d2d2d2", borderRight: "1px solid #d2d2d2"    }}
      >
        {rightLabel} :
      </td>
      <td style={{ width: "30%", padding: "8px", background: "#fff", borderBottom: "1px solid #d2d2d2"   }}>
        {rightValue || "-"}
      </td>
    </tr>
  );

  return (
    <div className="p20">
      <div className="p0 container container2">
<div className="col-md-3 sidebar" style={{float: "left"}}>
   
   

        <div className="clearfix"></div>

        {/* =====================================================
            CAR DETAILS
            (mirrors requestcardetailsfinal.php)
        ===================================================== */}
<div className="booking-wrapper">
<div className="your-car">Your Car</div>
<div className="car-box price-box">

<h2 className="car-title" style={{textAlign: "center", fontSize: "20px", lineHeight: "19px"}}>
  {car?.carmodel_brand || car?.cat_name || ""}  
  
      <br />
<span style={{fontSize: "14px", fontWeight: "500"}}> {car?.carmodel_name || ""}</span><br />
<span style={{fontSize: "14px", fontWeight: "500"}}> { car?.name || ""}</span></h2>
<img src={carImage}
alt={car?.carmodel_name || "Car"} alt="Selected car" className="car-img"/>
<div className="specs-row" style={{textAlign: "center", margin: "0px 14px"}}>
<span className="spec-tag">👤  
                  {car?.carmodel_passgrno ?? car?.passengers ?? 0}</span>
<span className="spec-tag">🧳  {car?.carmodel_luggno ?? car?.luggage ?? 0}</span>
<span className="spec-tag">❄️  {tt("airConditioning", "A/C.")}:{" "}{car?.carmodel_airconditionr ||
                    car?.airConditioning ||
                    tt("no", "No")}</span>
<span className="spec-tag">⚙️ Manual</span>
</div>

<br/>
</div>
</div>







        {/* <div className="contentsec">
          <div
            className="ourcarnewsec"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              padding: "15px",
            }}
          >
            <div className="carimg">
              {carImage ? (
                <img
                  src={carImage}
                  alt={car?.carmodel_name || "Car"}
                  className="img-responsive"
                  width="193"
                  height="126"
                  style={{
                    border: "1px solid #1b9ab5",
                    borderRadius: "5px",
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "193px",
                    height: "126px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #1b9ab5",
                    borderRadius: "5px",
                    color: "#999",
                  }}
                >
                  {tt("noImage", "No Image")}
                </div>
              )}
            </div>

            <div className="requestcarsec" style={{ flex: 1 }}>
              <div className="carname" style={{ fontWeight: "bold" }}>
              
              </div>

              <div className="cargroup">
               
              </div>

              <div
                className="clear"
                style={{
                  borderTop: "1px solid #4ebbd2",
                  margin: "10px 0",
                }}
              ></div>

              <div>
                <div className="cartext">
                 
                </div>

                <div className="cartext">
                  {tt("luggage", "Luggage")}:{" "}
                 
                </div>

                <div className="cartext">
                  {tt("doors", "Doors")}: {car?.carmodel_doors ?? "-"}
                </div>

                <div className="cartext">
                  {tt("airConditioning", "A.C.")}:{" "}
                  
                </div>
              </div>
            </div>
          </div>
        </div>*/}

        <div className="clearfix"></div>
</div>

<div className="col-md-9 main-content" style={{float: "left"}}>

 {/* =====================================================
            THANK YOU BANNER
        ===================================================== */}

        <div
          className="optionalcon"
          style={{
            marginBottom: "10px",
           
            boxShadow: "2px 5px 6px #b4b6b5",
          }}
        >
          <div
            className="rate"
            
          >
            {tt("thanksForRequest", "Thanks For Your Request")}
          </div>

          <div style={{ background: "#fff", padding: "15px" }}>
            <div className="finaltxt">
              {tt("dear", "Dear")}{" "}
              {form?.selTitle} {form?.firstname},
              <br />
            
              {tt(
                "requestThankYouBody",
                "Thanks for your request. Your request details are as follows. We would contact you very soon."
              )}
              {fullbooking_no && (
                <>
                  <br />
                 
                  {tt("referenceNumber", "Reference number")}:{" "}
                  <strong style={{color: "rgb(17, 155, 110)"}}>{fullbooking_no}</strong>
                </>
              )}
            </div>
          </div>
        </div>
        {/* =====================================================
            PERSONAL DETAILS (READ ONLY)
            (mirrors reqstfinal.php)
        ===================================================== */}

        <div
          className="insurances-bg price-box"
          style={{
            marginTop: "16px",
            
          }}
        >
          <div className="extra-details" >
          
              {tt("personalDetails", "Personal details")} :
            
          </div>

          <table
            width="100%"
            cellSpacing="1"
            cellPadding="1"
            style={{ borderCollapse: "collapse" }}
          >
            <tbody>
              <Row
                leftLabel={tt("name", "Name")}
                leftValue={`${form?.selTitle || ""} ${
                  form?.firstname || ""
                }`}
                rightLabel={tt("phoneNo", "Phone no")}
                rightValue={form?.txtphone}
              />

              <Row
                leftLabel={tt("familyName", "Family name")}
                leftValue={form?.lastname}
                rightLabel={tt("mobileNo", "Mobile no")}
                rightValue={form?.txtmobile}
              />

              <Row
                leftLabel={tt("emailId", "Email ID")}
                leftValue={form?.txtemail}
                rightLabel={tt("homeAddress", "Home Address")}
                rightValue={form?.txtaddress}
              />

              <Row
                leftLabel={tt("pickupLocation", "Pick up location")}
                leftValue={criteria?.pickLocationName}
                rightLabel={tt("zipCode", "Zip code")}
                rightValue={form?.txtpostcode}
              />

              <Row
                leftLabel={tt("dropoffLocation", "Drop off location")}
                leftValue={criteria?.dropLocationName}
                rightLabel={tt("city", "City")}
                rightValue={form?.txtcity}
              />

              <Row
                leftLabel={tt("driver", "Driver")}
                leftValue={criteria?.driverAgeLabel}
                rightLabel={tt("country", "Country")}
                rightValue={form?.txtcountry}
              />

              <Row
                leftLabel={tt("pickupComments", "Pick up comments")}
                leftValue={form?.txtpickdetails}
                rightLabel={tt("dropoffComments", "Drop off comments")}
                rightValue={form?.txtdropdetails}
              />

              <tr>
                <td
                  
                  style={{ padding: "8px", background: "#fff", fontWeight: "600" }}
                >
                  {tt("regularClient", "Regular client")} :
                </td>
                <td colSpan={3} style={{ padding: "8px", background: "#fff" }}>
                  {criteria?.regularClientLabel || "-"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="clearfix"></div>

        <div style={{ textAlign: "center", margin: "25px 0" }}>
          <button
            type="button"
            className="btn btn-secondary1 py-3 px-4"
            onClick={() => navigate("/")}
          >
            {tt("backToHome", "Back to home")}
          </button>
        </div>

      </div>
    </div>
	</div>
  );
}

export default RequestSent;
